import React, { useEffect,useState } from 'react';
// import { Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import EventImg from 'Assets/event-img.jpg';
import { dateConvert, unixDateConversion, DaysDiff, HoursDiff } from 'utils/Helper';
// , unixTimeStamp, current_unix_stamp, get_current_unix_stamp
import './style.css';

function UpcomingEvents(props) {
  const [userData, setuserData] = useState(null);

  let event_time = props.Event_time;
  let event_month = props.Event_month;
  let event_year = props.Event_year;
  let event_date = props.Event_date;
  let event_hour = props.Event_slot;

  if (props.event_info) {
    let start_time = unixDateConversion(props.event_info.start_time);
    let start_time_conv = dateConvert(start_time)
    let time_slot = start_time_conv.hour;
    //var selectedDate = start_time;
      
    let days_left;
    if (start_time && start_time > new Date()) {
      let day_diff = DaysDiff(start_time);
      let hour_diff = HoursDiff(start_time);
      days_left = "Starts in " + day_diff + " days, " + hour_diff + " hours";
    } else {
      days_left = "Completed";
    }
    
    event_time = days_left;
    event_hour = start_time_conv.hour;
    event_month = start_time_conv.month;
    event_year = start_time_conv.year;
    event_date = start_time_conv.date;
  }

  useEffect(() => {
    if (props.Event_img !== undefined) {
      let url = props.Event_img;
      let array = url.split("/");
      setuserData(`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_640x360/${array[5]}`);
    }
    
  },[props.Event_img]);
  
  return (
      <Link to={props.Event_link}>
      <div className="event-block">
        <div className="event-img">
          <div className="event-img-body">
          <img src={userData !== null  ? userData : EventImg} alt="img" className="img-fluid thumbnail-img" />
          </div>
          <span className="event-time">{event_time}</span>
        </div>
        <div className="event-brief">
          <div className="event-date">
            <h3>{event_month} {event_date}</h3>
            <h4>{event_year}</h4>
          </div>
          <div className="event-name">
            {
              props.Event_place
              ?
              <span style={{ color: "#007bff" }}>{props.Event_place} <i className="fa fa-long-arrow-right"></i> {props.Event_title}</span>
              :
              <span style={{ color: "#007bff" }}>{props.Event_title}</span>
            }
            {/* 
            {props.Event_place} <span>Next <i className="fa fa-long-arrow-right"></i> Vol {props.Event_vol}</span>
            */}
            {
              (props.Event_venues !== undefined && props.Event_venues !== null && props.Event_venues !== '' && event_hour !== undefined) 
              ?
              <h5>{props.Event_venues}:{props.Event_slot}</h5>
              :
              (event_hour !== undefined)
              ?
              <h5>Start Time: {event_hour}</h5>
              :
              null
            }
            
            {/* Martyrs' : */}
          </div>
        </div>
      </div>
      </Link>
  );
}

export default UpcomingEvents;
